<mad-primary-button [title]="'Save'">Save</mad-primary-button>
<mad-outline-button [title]="'Cancel'">Cancel</mad-outline-button>
<mad-danger-button>Delete forever</mad-danger-button>
<mad-link-button [title]="'Add Item'">Add Item</mad-link-button>
<mad-primary-button [title]="'Disabled'" [disabled]="true">Disabled</mad-primary-button>
<mad-icon-button [title]="'Create'">
  <mat-icon>create</mat-icon>
</mad-icon-button>
<br /><br />
<mad-button-group>
  <button mat-stroked-button madButton>Group 1</button>
  <button mat-stroked-button madButton>Group 2</button>
  <button mat-stroked-button madButton>Group 3</button>
</mad-button-group>
